var styleDataHash = "ebc16d9d";
const injectCss = (() => {
  var css = `.ThZdb{align-items:center;background-color:#fff;box-sizing:border-box;color:var(--ricos-settings-text-color,#000);display:flex;font-size:14px;height:40px;padding-left:20px;padding-right:20px;width:100%}.ThZdb *,.ThZdb :after,.ThZdb :before{box-sizing:inherit}.ThZdb input{box-sizing:border-box}.ThZdb>*{flex:1}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var list_item_toggle_default = {
  "container": "ThZdb"
};
export {
  list_item_toggle_default as default,
  injectCss
};
//# sourceMappingURL=list-item-toggle-scss.js.map
